import { useState } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { CollapsibleCard } from 'taboola-ultimate-ui';
import { CollapsibleCardProvider } from 'components';
import { ValidationSection } from 'modules/taboola-common-frontend-modules/validations';
import styles from './codelessCollapsibleCard.module.scss';

const classNameBuilder = classnames.bind(styles);

export const CodelessCollapsibleCard = ({
    id: _id,
    description,
    isInitiallyCollapsed: _isInitiallyCollapsed = false,
    containerClassName,
    headerClassName,
    descriptionClassName,
    children,
    collapsed: _collapsed,
    setCollapsed: _setCollapsed,
    ...rest
}) => {
    const [isCollapsed, setIsCollapsed] = useState(true);
    return (
        <ValidationSection>
            <CollapsibleCardProvider setCollapsed={setIsCollapsed}>
                <CollapsibleCard
                    containerClassName={classNameBuilder('card-container', containerClassName)}
                    headerClassName={classNameBuilder('collapsible-header', headerClassName)}
                    bodyClassName={styles['collapsible-body']}
                    iconHoverClass={styles['arrow-icon-hover']}
                    iconClassName={classNameBuilder('icon', { 'icon-rotated': isCollapsed })}
                    collapsed={isCollapsed}
                    setCollapsed={setIsCollapsed}
                    {...rest}
                >
                    {Boolean(description) && (
                        <div className={classNameBuilder('description', descriptionClassName)}>{description}</div>
                    )}
                    {children}
                </CollapsibleCard>
            </CollapsibleCardProvider>
        </ValidationSection>
    );
};

CodelessCollapsibleCard.propTypes = {
    description: PropTypes.node,
    children: PropTypes.node,
    id: PropTypes.string.isRequired,
    isInitiallyCollapsed: PropTypes.bool,
    containerClassName: PropTypes.string,
    headerClassName: PropTypes.string,
    descriptionClassName: PropTypes.string,
    customOnCollapse: PropTypes.func,
    customCollapsed: PropTypes.bool,
};

export default CodelessCollapsibleCard;
